import { render, staticRenderFns } from "./DatePermisos.vue?vue&type=template&id=b94e2cfc"
import script from "./DatePermisos.vue?vue&type=script&lang=js"
export * from "./DatePermisos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports